import { RouterModule } from '@angular/router';
import { DfIconModule } from '@lib/fresco';
import { FtpUploadLinkComponent } from './ftp-upload-link/ftp-upload-link.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [FtpUploadLinkComponent],
  exports: [FtpUploadLinkComponent],
  imports: [CommonModule, DfIconModule, RouterModule],
})
export class FtpSharedModule {}
